import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import loading from './modules/loading'
import snackbar from './modules/snackbar'
import systemMessageDialog from './modules/system-message-dialog'
import authorizationErrorDialog from './modules/authorization-error-dialog'
import alertMessage from './modules/alert-message'
import AdminModules from './modules/admin'
import DriverModules from './modules/driver'
import EdiRequestModules from './modules/edi_request'
import UpdateChecker from './modules/update_checker'
import freelySnackbar from "./modules/freelySnackbar";

Vue.use(Vuex)
const debug = process.env.VUE_APP_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    loading,
    snackbar,
    freelySnackbar,
    systemMessageDialog,
    authorizationErrorDialog,
    alertMessage,
    ...AdminModules,
    ...DriverModules,
    ...EdiRequestModules,
    UpdateChecker,
  },
  plugins: [
    createPersistedState({
      key: 'dxe'
    })
  ],
  strict: debug,
})

export default store
